import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
} from '@mui/material';
import { GroupsViewCreator } from '@app/view-creator';
import { useApp } from '@app/App.hook';
import { useAppCookies } from '@app/providers/AppCookieProvider';

interface AnyActiveCohortUserGuardProps {
  children: React.ReactNode;
}

export const AnyActiveCohortUserGuard: React.FC<AnyActiveCohortUserGuardProps> = ({ children }) => {
  const cookies = useAppCookies();
  const [loading, setLoading] = useState(true);
  const [isActive, setIsActive] = useState<boolean>(false);
  const { logout } = useApp();

  const checkForAnyActiveCohortUser = async () => {
    try {
      const groups = await new GroupsViewCreator().CreateView();
      if (groups.groups.length > 0) {
        setIsActive(true);
      }
    } catch {
      setIsActive(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cookies.profile.available) {
      setLoading(false); // ✅ ensure UI stabilizes during logout
      setIsActive(false);
      return;
    }
    checkForAnyActiveCohortUser();
  }, [cookies.profile.available]);

  if (loading) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  if (!isActive) {
    return (
      <Container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', height: '100vh' }}>
        <Paper sx={{ width: '100%', maxWidth: '500px' }}>
          <DialogTitle>Something&#39;s Not Quite Right</DialogTitle>
          <DialogContent>
            <Typography>
              🤔 We don&#39;t have you rostered with this We Hate Exercise team. If this is incorrect, please reach out
              to your team captain.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button variant={'contained'} onClick={logout} sx={{ margin: '0 auto 25px', width: '80%' }}>
              Logout
            </Button>
          </DialogActions>
        </Paper>
      </Container>
    );
  }

  return <>{children}</>;
};
